import axios from "axios";

export const getUserPermits = async (userID: any) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API}/Permit/user-permits?UserID=${userID}`
    );
    return response.data;
  } catch (error: any) {
    console.error(error);
    return error.response;
  }
};
